module.exports = {
    "crude": {
        "search": "Etsi",
        "actions": "Toiminnot",
        "nextPage": "Seuraava sivu",
        "lastPage": "Edellinen sivu",
        "back": "Takaisin",
        "empty": "tyhjä",
        "edit": "muokata",
        "create": "luoda",
        "data": "ennätys",
        "view": "näytä",
        "delete": "Poistaa",
        "save": "Tallentaa",
        "cancel": "Peruuttaa",
        "noContent": "Ei merkintöjä saatavilla. ",
        "resetFilter": "Nollaa suodattimet ja katso lisää sisältöä!",
        "createOwnTextField": "Luo oma tekstikenttäsi",
        "textFieldName": "tekstikentän otsikko",
        "textFieldValue": "Sisällys",
        "insertTextFieldLabel": "Kirjoita tekstikentän nimi!",
        "deleteTextField": "Poista tekstikenttä",
        "success": "Tallennus onnistui",
        "invalidDataFields": "Seuraavat tietokentät ovat virheellisiä:  ",
        "entries": "merkinnät",
        "entry": "sisääntulo",
        "tabDetail": "yksityiskohdat",
        "entity": "kokonaisuus",
        "of": "alkaen",
        "uploadNewFile": "Lataa tiedosto",
        "upload": "lataa",
        "confirm": "OK",
        "deleteFileQuestion": "Haluatko todella poistaa tämän tiedoston? ",
        "deleteFileQuestionTitle": "Vaara!",
        "deleteEntityQuestion": "Haluatko todella poistaa tämän kokonaisuuden? ",
        "deleteEntityQuestionTitle": "Vaara!",
        "errorLargeFileUpload": "Valittu tiedosto on liian suuri!",
        "useCroppedImage": "Käytä rajausta",
        "useOriginalImage": "Käytä alkuperäistä kuvaa",
        "available": "saatavilla",
        "searchColumn": "etsi sarake",
        "manageColumns": "Hallitse sarakkeita",
        "hideColumn": "piilota sarake",
        "pinToRight": "Kiinnitä sarake oikealle",
        "pinToLeft": "Kiinnitä sarake vasemmalle",
        "sortAsc": "Lajittele nousevaan järjestykseen",
        "sortDesc": "Lajittele laskevasti",
        "hideAll": "piilottaa kaikki",
        "showAll": "Näytä kaikki",
        "preview": "esikatselu",
        "title": "otsikko",
        "description": "Kuvaus",
        "tooltip": "työkaluvihje",
        "sort": "Järjestä",
        "settings": "asetukset",
        "incomingReference": "viite",
        "language": "Kieli",
        "deleteTabQuestionTitle": "Vaara!",
        "deleteTabQuestion": "Haluatko todella poistaa tämän välilehden? ",
        "deleteElementQuestionTitle": "Vaara!",
        "deleteElementQuestion": "Haluatko todella poistaa tämän kohteen? ",
        "configurationEditorDescriptionStringLayout": "Tässä sarakkeessa voidaan valita kolme vaihtoehtoa tekstin syöttämiseen:",
        "configurationEditorDescriptionEnumLayout": "Tämän sarakkeen elementtien valintaan voidaan valita kaksi vaihtoehtoa:",
        "configurationEditorDescriptionBooleanLayout": "Tämän sarakkeen elementtien valintaan voidaan valita kaksi vaihtoehtoa:",
        "configurationEditorDescriptionForeignEntityLayout": "Tämän sarakkeen elementtien valintaan voidaan valita kaksi vaihtoehtoa:",
        "stringLayoutsingleline": "yksi rivi",
        "stringLayoutmultiline": "monirivinen",
        "stringLayouteditor": "Rich Text Editor",
        "enumLayoutradio": "radiopainike",
        "enumLayoutdropdown": "pudota alas",
        "booleanLayoutcheckbox": "valintaruutu",
        "booleanLayoutswitch": "kytkimet",
        "foreignEntityLayoutpopUp": "ponnahdusikkuna",
        "foreignEntityLayoutautocomplete": "pudota alas",
        "foreignEntityLayoutlist": "lista",
        "formatTooltipbold": "Lihava",
        "formatTooltipitalic": "kursivoitu",
        "formatTooltipunderline": "alleviivattu",
        "formatTooltipstrike": "Yliviivattu",
        "formatTooltipclean": "selkeä muotoilu",
        "formatTooltipcodeBlock": "koodi",
        "formatTooltipblockquote": "Lainata",
        "formatTooltipcolor": "fontin väri",
        "formatTooltipbackground": "taustaväri",
        "formatTooltipfont": "fontti",
        "formatTooltipalign": "linjaus",
        "formatTooltipheader": "Fonttikoko",
        "formatTooltipsuper": "Yläindeksi",
        "formatTooltipsub": "alaindeksi",
        "formatTooltipordered": "Tilattu lista",
        "formatTooltipbullet": "Luettelo",
        "true": "Joo",
        "false": "ei",
        "selectEntity": "valitse kokonaisuus",
        "filter": "suodattaa",
        "useFilter": "Käytä suodattimia",
        "defaultFilter": "nollaa suodatin",
        "expand": "laajentaa",
        "hide": "piilottaa",
        "minimumSelectionError": "Vähintään {{min}} kohdetta on valittava.",
        "maximumSelectionError": "Enintään {{max}} merkintää voidaan valita."
    }
}
;